import React from 'react';
import { clsx } from 'clsx';
import { formatTimestamp } from '@/shared/utils/format';
import patterns from '@/shared/ui/styles/patterns.module.css';
import styles from './PageHeader.module.css';

interface PageHeaderProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  timestamp?: string | Date | null;
  /** Optional inline content appended after the "Last updated: …" timestamp. */
  timestampSuffix?: React.ReactNode;
  actions?: React.ReactNode;
  align?: 'left' | 'center';
  className?: string;
}

export function PageHeader({
  title,
  subtitle,
  timestamp,
  timestampSuffix,
  actions,
  align = 'left',
  className,
}: PageHeaderProps) {
  return (
    <div className={clsx(styles.header, align === 'center' && styles.headerCenter, className)}>
      <div className={styles.text}>
        <h1 className={styles.title}>{title}</h1>
        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
        {timestamp && (
          <p className={patterns.timestamp}>
            Last updated: {formatTimestamp(timestamp)}
            {timestampSuffix}
          </p>
        )}
      </div>
      {actions && <div className={styles.actions}>{actions}</div>}
    </div>
  );
}
